import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import SpriteComponent from '../../../Component/Render/Sprite';

interface IAlphaMeta {
    duration: number;
    startAlpha: number;
    endAlpha: number;
    delay?: number;
    easing?: (k: number) => number;
}

export class Alpha extends AnimationClip<IAlphaMeta> {
    public *execute(
        gameObject: GameObject,
        meta: IAlphaMeta
    ): IterableIterator<number> {
        let renderable: Renderable;
        if (gameObject.hasComponent<Renderable>(Renderable)) {
            renderable = gameObject.getComponent<Renderable>(Renderable);
        } else if (gameObject.hasComponent(SpriteComponent)) {
            renderable = gameObject.getComponent(SpriteComponent);
        } else {
            console.warn(
                'Alpha transition failed. No renderable component found'
            );
        }
        const tween = this.getTween(renderable);

        renderable.alpha = meta.startAlpha;
        renderable.visible = true;

        tween
            .to({ alpha: meta.endAlpha }, meta.duration)
            .easing(meta.easing || Easing.Linear.None);

        if (meta.delay) {
            yield* delay(meta.delay);
        }

        yield* this.startTween(tween);
    }
}
